export default "__VITE_ASSET__DDnEYUnW__"